export const enum ApiQueryKey {
  /**
   * 商品卡片
   */
  ItemCardProduct = 'itemCardProduct',
  /**
   * 订单卡片
   */
  OrderCardTrade = 'orderCardTrade',
  /**
   * 议价卡片
   */
  OfferCard = 'offerCard',
  /**
   * 商品列表
   */
  ProductList = 'productList',
  /**
   * 会话列表
   */
  ConversationList = 'conversationList',
  /**
   * ToDo 任务列表
   */
  ToDoTaskList = 'todoTaskList',
  /**
   * 优惠券列表
   */
  VoucherList = 'voucherList',
  /**
   * 优惠券卡片
   */
  VoucherCard = 'voucherCard',
  /**
   * 退货/退款卡片
   */
  ReturnRefundCard = 'returnRefundCard',
  /**
   * QAPairProduct
   */
  QAPairProduct = 'QAPairProduct',
  /**
   * 店铺区域信息
   */
  StoreRegionInfo = 'StoreRegionInfo',
  QAPairReply = 'QAPairReply',
  LogisticsCard = 'LogisticsCard',
  /**
   * 平台站点店铺状态统计
   */
  StorePlatformRegionStatusCount = 'StorePlatformRegionStatusCount',
  /**
   * 查询店铺管理列表
   */
  AdminStores = 'AdminStores',
  /**
   * 查询会话顶部信息
   */
  ConversationTopBarInfo = 'ConversationTopBarInfo',
  /**
   * 查询订单列表
   */
  OrderList = 'OrderList',
  /**
   * 同步会话列表
   */
  SyncConversationList = 'SyncConversationList',
}
